export default "__VITE_ASSET__DcnOL4DC__"